import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { LANGUAGES } from 'src/app/constants/lang';
import { MESSAGE, NO_LOGO } from 'src/app/constants/storage-elements';
import { ROUTES } from 'src/app/route/routes';
import { HomeService } from 'src/app/service/home.service';
import { LocaleService } from 'src/app/service/locale.service';
import { SessionStorageService } from 'src/app/service/session-storage.service';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-pre-landing',
  templateUrl: './pre-landing.component.html',
  styleUrls: ['./pre-landing.component.scss'],
  standalone: false
})
export class PreLandingComponent implements OnInit {
  // loading = true;
  token!: string;
  shipId!: string;

  constructor(
    private route: Router,
    private router: ActivatedRoute,
    private userService: UserService,
    private service: HomeService,
    private spinner: SpinnerService,
    private sStorager: SessionStorageService,
    private locale: LocaleService
  ) {
    this.router.queryParams.subscribe((param) => {
      if (param) {
        this.token = param['key'];
        this.shipId = param['shipId'];
      }
    });
  }

  ngOnInit() {
    // this.loading = false;
    this.spinner.hide();
    if (this.token && this.shipId) {
      this.login();
    }
  }

  goTo(path?: string) {
    switch (path) {
      case 'home':
        if (this.userService.token) {
          this.route.navigate([ROUTES.HOME.path]);
        } else {
          this.route.navigate([ROUTES.LOGIN.path]);
        }
        break;
    }
  }

  login() {
    this.spinner.show();
    let body = {
      key: this.token,
      ship: this.shipId
    };

    this.userService.login(body).subscribe({
      next: (res: any) => {
        const {flux, data} = res;

        const event_category_flux = data?.event?.event_category_flux? data.event.event_category_flux : undefined;
        const category = data?.category? data.category : undefined;
        this.userService.setLoginInfo(res.auth);

        if (this.token) {
          this.sStorager.addElement('NO_LOGO', NO_LOGO);
        }

        if (res.language) {
          let lang = res.language;
          if (!Object.values(LANGUAGES).includes(lang as LANGUAGES)) {
            lang = LANGUAGES.default;
          }
          this.locale.changeLanguage(lang);
        }

        let baseUrl = event_category_flux? event_category_flux+'/' : category? category+'/' : undefined;

        return this.handleNavigation(baseUrl, this.route, flux, data, this.service, this.sStorager);
      },
      error: (err) => {
        this.spinner.hide();
      },
    });
  }

  handleNavigation(baseUrl: string | undefined, route: Router, flux: any, data: any, service: HomeService, sStorager: SessionStorageService) {
    if (baseUrl) {
        if (flux === 'RESERVATIONS') {
          this.spinner.hide();
          return route.navigate([baseUrl+ROUTES.RESERVATION_LIST.path]);
        } else if (flux === 'CALENDAR' && data) {
          service.saveEventObject(data.event);
          this.spinner.hide();
          return route.navigate([baseUrl+ROUTES.EVENT_CALENDAR.path]);
        } else if (flux === 'HOME') {
          this.spinner.hide();
          return route.navigate([baseUrl+ROUTES.HOME.path]);
        }else if (flux === 'NO_BOOK' && data) {
            this.spinner.hide();
            sStorager.addElement(data.message, MESSAGE);
            return route.navigate([ROUTES.MESSAGE.path]);
        }
    } 
    this.spinner.hide();
    return route.navigate([ROUTES.HOME.path]);
  }
}



